import actions from '../../../../redux/actions/ui/dataImport/strategies/moCreateStrategy.js'
import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from './ReconcileForm.js'
import EditForm from './EditForm.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default function MOCreateStrategy(props) {
  return (
    <BaseStrategy
      {...props}
      actions={actions}
      EditForm={EditForm}
      ReconcileForm={ReconcileForm}
    />
  )
}

MOCreateStrategy.title = actions.title
const option = {
  value: 'create_mo',
  display: 'Create MFG Order',
  category: 'manufacturing',
  Component: MOCreateStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
MOCreateStrategy.option = option
